import { useSelector } from 'react-redux';
import { getSections, getIsSectionBoxedHelper
// @ts-expect-error no declarations found for module
} from 'EmailEditorUI/redux/selectors/sectionSelectors';
// @ts-expect-error no declarations found for module
import { getLayoutSettings } from 'EmailEditorUI/redux/selectors/styleSettingsSelectors';
import { ElementVisibilityContextProvider } from 'LayoutBuilderUI/context/ElementVisibilityContext';
import SectionBoundariesContextProvider from 'LayoutBuilderUI/context/SectionBoundariesContext';
import useVisibleBoxBoundaries from 'LayoutBuilderUI/hooks/useVisibleBoxBoundaries';
import { jsx as _jsx } from "react/jsx-runtime";
function SectionList({
  children
}) {
  const layoutSettings = useSelector(getLayoutSettings);
  const sections = useSelector(getSections);
  const {
    bottom,
    top
  } = useVisibleBoxBoundaries(layoutSettings, sections);
  return sections.map((section, index) => /*#__PURE__*/_jsx(SectionBoundariesContextProvider, {
    value: {
      borderBottom: bottom === index,
      borderTop: top === index,
      index,
      isBoxed: getIsSectionBoxedHelper(layoutSettings, index)
    },
    children: /*#__PURE__*/_jsx(ElementVisibilityContextProvider, {
      styles: section.get('style'),
      children: children(section.get('id'), index)
    })
  }, section.get('id')));
}
export default SectionList;